// @flow strict

import * as React from 'react';
import styles from './styles.scss';
import type { FeaturedArticleType } from '../types';
import ArticleMeta from '../../../../internal/ArticleMeta';
import ResponsiveImage from '../../../../internal/ResponsiveImage';

export default (props: FeaturedArticleType) => (
  <div className={styles.featured}>
    <ResponsiveImage
      className={styles.image}
      src={props.image}
      alt={props.alt}
      defaultSize={{ width: 750 }}
      srcSet={[{ mediaMaxWidth: 600, width: 536 }, { mediaMaxWidth: 400, width: 336 }]}
    />
    <h3>
      <a href={props.href} className={styles.title}>
        {props.title}
      </a>
    </h3>
    <ArticleMeta
      author={props.author}
      categories={props.categories}
      date={props.date}
      className={styles.meta}
    />
    <p className={styles.summary}>{props.intro}</p>
  </div>
);
